module.exports = __webpack_public_path__ + "static/it-cloud-dbb749dbbd4814fa4604cb26055f9fa0.svg";